import { render, staticRenderFns } from "./cardRemoval.vue?vue&type=template&id=c4fe034e&"
import script from "./cardRemoval.vue?vue&type=script&lang=js&"
export * from "./cardRemoval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports